import EmbeddedMap from 'components/Pages/EmbeddedMap/EmbeddedMap';

export default EmbeddedMap;
